import * as React from "react";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";

import {
  updateExercise,
  UpdateExercise
} from "../../../resources/user/user.actions";
import { IExercise } from "../../../resources/user/types";
import EditExercise from "./edit";

interface IProps {
  exercise: IExercise;
  updateExercise: UpdateExercise;
}

function Exercise({ exercise, updateExercise }: IProps) {
  const { id, workoutId } = useParams<{ id: string; workoutId: string }>();

  async function onSubmit(exerciseId: string, newValues: Partial<IExercise>) {
    await updateExercise(id, workoutId, exerciseId, newValues);
  }

  return <EditExercise exercise={exercise} onSubmit={onSubmit} />;
}
export default connect(null, { updateExercise })(Exercise);
